import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";

const MultiSelectWithCheckboxEdit = ({
  options,
  selectedValues = [], // Pre-selected IDs
  onChange,
  isDisabled,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);


  // Populate pre-selected options during initialization or when selectedValues change
  useEffect(() => {
    const preselected = options.filter((option) =>
      selectedValues.includes(option.id)
    );
    setSelectedOptions(preselected);
  }, [selectedValues, options]);

  // Handle selection changes
  const handleSelectionChange = (selected) => {
    setSelectedOptions(selected || []); // Update state
    const selectedIds = (selected || []).map((option) => option.id); // Extract IDs
    const selectedNames = (selected || []).map((option) => option.label); // Extract labels
    onChange({ selectedIds, selectedNames }); // Pass both IDs and names to parent
  };

  // Custom rendering for options with checkboxes
  const customOption = ({ data, innerRef, innerProps }) => {
    const isSelected = selectedOptions.some((option) => option.id === data.id);

    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{ display: "flex", alignItems: "center", padding: "5px 10px" }}
      >
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          style={{ marginRight: "10px" }}
        />
        {data.label}
      </div>
    );
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {isDisabled ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
          >
            <path
              d="M12.9425 1.97314L8.0525 6.29891C7.475 6.80978 6.53 6.80978 5.9525 6.29891L1.0625 1.97314"
              stroke="#87909E"
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ) : (
          <span class=" pointer-events-none">
            <svg
              className=""
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                stroke="#245CEA"
                strokeWidth="2"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </span>
        )}
      </components.DropdownIndicator>
    );
  };

  // Define the styles and behavior for the select box
  const customComponents = {
    Option: customOption,
    DropdownIndicator,
    IndicatorSeparator: () => null,
  };

  return (
    <Select
      options={options} // List of options
      components={customComponents} // Use custom checkbox renderer
      isMulti // Enable multiple selection
      isDisabled={isDisabled}
      value={selectedOptions} // Bind selected options
      onChange={handleSelectionChange} // Handle changes
      closeMenuOnSelect={false} // Keep dropdown open
      hideSelectedOptions={false} // Show already selected options
      placeholder="Search and select options..."
      className="focus:none"
    />
  );
};

export default MultiSelectWithCheckboxEdit;
